






































































































































































































































































































































import { wrapper as AssetManagerComposer } from '@/composers/asset-manager';
import { component as DirtyCheckComposer } from '@/composers/dirty-check';
import { component as StoreRegisterComposer } from '@/composers/store-register';
import store from '../../stores/linesheet';
import messages from '../../messages';
import View from './View';

const storeName = 'linesheet';

export default AssetManagerComposer(
  DirtyCheckComposer(storeName,
    StoreRegisterComposer(
      storeName,
      store,
      View(storeName),
    ),
  ),
  messages,
) as IView;
